import React from "react";
import { Row, Col, Accordion } from "react-bootstrap";
import AboutSlider from "./AboutSlider";
function HomeFAQ() {
  return (
    <>
      <div className="container" id="chisiamo">
        <div className="spacing">
          <Row className="homeFAQRow">
            <Col xl={6} lg={6} md={6}>
              <div className="titleFont spacing">
                <h2>Italy Cash Puglia</h2>
                <h3>Il Professional Stores di Tatò Paride S.p.A. </h3>
              </div>
              <div className="max-w-2xl mx-auto">
                <p className="service-text mb-4">
                  Con 6 Cash nelle province pugliesi, per il mercato Ho.Re.Ca e la clientela professionale, offriamo soluzioni mirate e selezionate sulla base delle esigenze specifiche e contribuiamo a valorizzare l'imprenditoria locale, grazie all'ampio assortimento e ai servizi mirati per dettaglianti food e no food, operatori dell'Ho.Re.Ca e professionisti con partita IVA. Questa per noi è la base su cui instaurare rapporti di fiducia a lungo termine.
                </p>
                <p className="service-text mb-4">
                  Il consorzio nazionale cui apparteniamo, Italy Cash, è nato nel 2012 e da sempre garantisce massima professionalità del servizio offerto alla clientela attraverso:
                </p>
                <ul className="service-text list-disc pl-5 mb-6">
                  <li>due linee di prodotti ad alta performance di utilizzo</li>
                  <li>un assortimento costantemente aggiornato, che segue l'andamento del mercato</li>
                  <li>formati professionali specifici che evitano gli sprechi</li>
                </ul>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6}>
              <AboutSlider />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default HomeFAQ;
